import React, { useState } from 'react';
import { IconButton, Tooltip } from '@material-ui/core';
import { ImageIcon } from "@icarius-icons";
import { getLocalizedString } from "@icarius-localization/strings";
import GalleryDialog from "@icarius-common/galleryDialog/components/index";

function NoteFormUploadImage(props) {

    const { handleSubmit, noteImg } = props;
    const [galleryDialogIsOpen, setGalleryDialogIsOpen] = useState(false);

    return (
        <>
            <label htmlFor="button-file">
                <Tooltip title={getLocalizedString("addImage")} placement="bottom">
                    <IconButton className="w-32 h-32 mx-4 p-0" component="span" onClick={() => setGalleryDialogIsOpen(true)}>
                        <ImageIcon fontSize="small" style={{ fill: "var(--mainText)" }} />
                    </IconButton>
                </Tooltip>
            </label>
            {
                galleryDialogIsOpen &&
                <GalleryDialog
                    open={galleryDialogIsOpen}
                    initialValue={noteImg}
                    type={"notes"}
                    handleSubmit={(img) => handleSubmit(img)}
                    handleClose={() => setGalleryDialogIsOpen(false)}
                />
            }
        </>
    );
}

export default NoteFormUploadImage;
